<template>
  <div>
    <b-overlay
      :show="show"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
      <b-card title="">
        <b class="pr-1">Sparing</b> <span class="dot normal" /> Normal <span class="dot abnormal" /> Abnormal
        <b
          class="sidebar-right"
          style="margin-left: 1rem;"
        >
          <b-link
            :to="{ path: '/dashboard/sparingtv-rpsm' }"
            style="color: #1e00ff;"
          >
            <feather-icon icon="GlobeIcon" />
          </b-link>
        </b>
        <b class="sidebar-right">
          {{ datenow }}
        </b>
      </b-card>
      <b-row class="mt-3">
        <b-col
          cols="12"
          md="6"
        >
          <b-row
            xl="12"
            sm="12"
          >
            <b-col
              sm="4"
              md="4"
            >
              <b-row>
                <b-col cols="12">
                  <b-card title="PH">
                    <!-- apex chart -->
                    <vue-apex-charts
                      type="radialBar"
                      height="205"
                      class="my-2"
                      :options="goalOverviewRadialBarTemperature"
                      :series="[valueToPercent(realtime_ph)]"
                    />
                  </b-card>
                </b-col>
                <b-col
                  v-if="realtime_alarm != null"
                  cols="12"
                >
                  <b-card title="Alarm">
                    <b-badge
                      v-if="realtime_alarm"
                      variant="success"
                    >
                      Active
                    </b-badge>
                    <b-badge
                      v-else
                      variant="danger"
                    >
                      Nonactive
                    </b-badge>
                  </b-card>
                </b-col>
              </b-row>
            </b-col>
            <b-col md="8">
              <b-row>
                <b-col
                  cols="6"
                  md="6"
                >
                  <b-card
                    title="COD"
                    class="my-custom-class"
                    :style="{ backgroundColor: realtime_cod < 0 || realtime_cod > 100 ? '#FC4C02' : 'green' }"
                  >
                    <div class="ml-2">
                      <h1>
                        <font color="white">
                          {{ realtime_cod }}
                        </font>
                        <small>
                          <font color="white"> ppm </font>
                        </small>
                      </h1>
                    </div>
                  </b-card>
                </b-col>

                <!-- <b-col
                  cols="6"
                  md="6"
                >
                  <b-card
                    title="NH3N"
                    class="my-custom-class"
                    :style="{ backgroundColor: realtime_tss < 0.00001|| realtime_tss > 10 ? '#FC4C02' : 'green' }"
                  >
                    <div class="ml-2">
                      <h1>
                        <font color="white">
                          {{ realtime_tss }}
                        </font><small>
                          <font color="white">ppm </font>
                        </small>
                      </h1>
                    </div>
                  </b-card>
                </b-col> -->
                <b-col
                  cols="6"
                  md="6"
                >
                  <b-card
                    title="TSS"
                    class="my-custom-class"
                    :style="{ backgroundColor: realtime_nh3n < 0 || realtime_nh3n > 150 ? '#FC4C02' : 'green' }"
                  >
                    <div class="ml-2">
                      <h1>
                        <font color="white">
                          {{ realtime_nh3n }}
                        </font><small>
                          <font color="white">ppm </font>
                        </small>
                      </h1>
                    </div>
                  </b-card>
                </b-col>
                <b-col
                  cols="6"
                  md="6"
                >
                  <b-card title="Debit">
                    <h1>
                      <font color="">
                        {{ realtime_debit }}
                      </font><small>
                        <font color="">m3/h</font>
                      </small>
                    </h1>
                  </b-card>
                </b-col>
                <b-col
                  v-if="realtime_ups != null"
                  cols="6"
                  md="6"
                >
                  <b-card title="UPS">
                    <b-badge
                      v-if="realtime_ups"
                      variant="success"
                    >
                      Active
                    </b-badge>
                    <b-badge
                      v-else
                      variant="danger"
                    >
                      Nonactive
                    </b-badge>
                  </b-card>
                </b-col>
                <b-col
                  v-if="realtime_pln != null"
                  cols="6"
                  md="6"
                >
                  <b-card title="PLN">
                    <b-badge
                      v-if="realtime_pln"
                      variant="success"
                    >
                      Active
                    </b-badge>
                    <b-badge
                      v-else
                      variant="danger"
                    >
                      Nonactive
                    </b-badge>
                  </b-card>
                </b-col>
              </b-row>
            </b-col>
            <b-col
              cols="12"
              lg="12"
            >
              <b-card title="PH Chart">
                <vue-apex-charts
                  type="area"
                  :height="370"
                  :options="lineChartSimpleTemperaturePh.chartOptions"
                  :series="lineChartSimpleTemperaturePh.series"
                />
              </b-card>
            </b-col>
          </b-row>
        </b-col>
        <b-col
          cols="12"
          md="6"
        >
          <b-row
            xl="12"
            sm="12"
          >
            <b-col
              class="custom col-md-6"
              cols="12"
              md="6"
            >
              <b-row>
                <b-col cols="12">
                  <b-card title="COD Chart">
                    <vue-apex-charts
                      class="vue-apex-charts"
                      type="area"
                      :height="340"
                      :options="lineChartSimpleTemperatureCod.chartOptions"
                      :series="lineChartSimpleTemperatureCod.series"
                    />
                  </b-card>
                </b-col>
              </b-row>
            </b-col>
            <b-col
              class="custom col-md-6"
              cols="12"
              md="6"
            >
              <b-row
                xl="12"
                sm="12"
              >
                <b-col
                  cols="12"
                  md="12"
                >
                  <b-card title="TSS Chart">
                    <vue-apex-charts
                      type="area"
                      :height="340"
                      :options="lineChartSimpleTemperatureTss.chartOptions"
                      :series="lineChartSimpleTemperatureTss.series"
                    />
                  </b-card>
                </b-col>
              </b-row>
            </b-col>
            <b-col
              class="custom col-md-6"
              cols="12"
              md="6"
            >
              <b-row
                xl="12"
                sm="12"
              >
                <b-col
                  cols="12"
                  md="12"
                >
                  <b-card title="Debit Chart">
                    <vue-apex-charts
                      type="area"
                      :height="340"
                      :options="lineChartSimpleTemperatureDebit.chartOptions"
                      :series="lineChartSimpleTemperatureDebit.series"
                    />
                  </b-card>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row
        xl="12"
        sm="12"
        style="display: none;"
      >
        <b-col
          cols="3"
          md="4"
          class="mb-md-0 mb-2"
        >
          <b-row
            xl="12"
            sm="12"
          >
            <b-col
              cols="12"
              md="12"
              class="mb-md-0 mb-2"
            >
              <b-card title="">
                <div
                  class="my-auto"
                  style="text-align: center;"
                >
                  <b-row
                    xl="12"
                    sm="12"
                  >
                    <b-col
                      cols="12"
                      md="12"
                      style="text-align: center;"
                    >
                      <b-img :src="icon1" />
                    </b-col>
                  </b-row>
                </div>
                <div
                  class="my-auto"
                  style="text-align: center;"
                >
                  <h1 class="font-weight-bolder mb-0">
                    32 &#x2103;
                  </h1>
                </div>
                <div
                  class="my-auto"
                  style="text-align: center;"
                >
                  <b-row
                    xl="12"
                    sm="12"
                  >
                    <b-col
                      cols="6"
                      md="6"
                    >
                      <p class="font-weight-bolder mb-0">
                        Overcast
                      </p>
                    </b-col>
                    <b-col
                      cols="6"
                      md="6"
                    >
                      <p class="font-weight-bolder mb-0">
                        Rainfall
                      </p>
                    </b-col>
                  </b-row>
                </div>
                <hr>
                <b-row
                  xl="12"
                  sm="12"
                >
                  <b-col
                    cols="12"
                    md="12"
                  >
                    <p class="font-weight-bolder mb-1">
                      <feather-icon icon="CalendarIcon" /> {{ datenow }}
                    </p>
                  </b-col>
                  <b-col
                    cols="12"
                    md="12"
                  >
                    <p class="font-weight-bolder mb-1">
                      <feather-icon icon="MapPinIcon" /> Wind Velocity
                    </p>
                  </b-col>
                  <b-col
                    cols="12"
                    md="12"
                  >
                    <p class="font-weight-bolder mb-1">
                      <feather-icon icon="MapPinIcon" /> Wind Direction
                    </p>
                  </b-col>
                  <b-col
                    cols="12"
                    md="12"
                  >
                    <p class="font-weight-bolder mb-1">
                      <feather-icon icon="MapPinIcon" /> Barometric Pressure
                    </p>
                  </b-col>
                  <b-col
                    cols="12"
                    md="12"
                  >
                    <p class="font-weight-bolder mb-1">
                      <feather-icon icon="MapPinIcon" /> PM 2.5
                    </p>
                  </b-col>
                  <b-col
                    cols="12"
                    md="12"
                  >
                    <p class="font-weight-bolder mb-1">
                      <feather-icon icon="MapPinIcon" /> PM 10
                    </p>
                  </b-col>
                  <b-col
                    cols="12"
                    md="12"
                  >
                    <p class="font-weight-bolder mb-1">
                      <feather-icon icon="MapPinIcon" /> Sound Level
                    </p>
                  </b-col>
                  <b-col
                    cols="12"
                    md="12"
                  >
                    <p class="font-weight-bolder mb-1">
                      <feather-icon icon="MapPinIcon" /> CO2
                    </p>
                  </b-col>
                  <b-col
                    cols="12"
                    md="12"
                  >
                    <p class="font-weight-bolder mb-1">
                      <feather-icon icon="MapPinIcon" /> Company
                    </p>
                  </b-col>
                  <b-col
                    cols="12"
                    md="12"
                  >
                    <p class="font-weight-bolder mb-1">
                      <feather-icon icon="MapPinIcon" /> Location
                    </p>
                  </b-col>
                  <b-col
                    cols="12"
                    md="12"
                  >
                    <p class="font-weight-bolder mb-1">
                      <feather-icon icon="MapPinIcon" /> Area
                    </p>
                  </b-col>
                </b-row>
              </b-card>
            </b-col>
          </b-row>
        </b-col>
        <b-col
          cols="8"
          md="8"
          class="mb-md-0 mb-2"
        >
          <b-row
            xl="12"
            sm="12"
          />
        </b-col>
      </b-row>
    </b-overlay>
  </div>
</template>
<script>
import {
  BCard, BOverlay, BImg, BLink, BBadge, BRow, BCol,
} from 'bootstrap-vue'
import moment from 'moment'
import { computed, watch } from '@vue/composition-api'
import useAppConfig from '@core/app-config/useAppConfig'
import { mapState } from 'vuex'
import VueApexCharts from 'vue-apexcharts'
import { $themeColors } from '@themeConfig'

import icon1 from '@/assets/images/icons/GroupCloud.png'
import icon2 from '@/assets/images/icons/WaterReservoir.png'

const getCurrentTime = () => moment(String(new Date())).format("dddd, DD MMM' YYYY LTS")
const $strokeColor = '#ebe9f1'
const $textHeadingColor = '#5e5873'
const $goalStrokeColor2 = '#51e5a8'

export default {
  components: {
    VueApexCharts, BCard, BOverlay, BImg, BBadge, BLink, BRow, BCol,
  },
  setup() {
    const { skin } = useAppConfig()

    const isDark = computed(() => skin.value === 'dark')
    watch(isDark, (newValue, oldValue) => {
      if (newValue !== oldValue) {
        // Memuat ulang halaman saat nilai isDark berubah
        window.location.reload()
      }
    })
    return { skin, isDark }
  },
  data() {
    return {
      goalOverviewRadialBarTemperature: {
        chart: {
          height: 245,
          type: 'radialBar',
          sparkline: {
            enabled: true,
          },
          dropShadow: {
            enabled: true,
            blur: 3,
            left: 1,
            top: 1,
            opacity: 0.1,
          },
        },
        colors: [$goalStrokeColor2],
        plotOptions: {
          radialBar: {
            offsetY: -10,
            startAngle: -150,
            endAngle: 150,
            hollow: {
              size: '57%',
            },
            track: {
              background: $strokeColor,
              strokeWidth: '50%',
            },
            dataLabels: {
              name: {
                show: false,
              },
              value: {
                color: $textHeadingColor,
                fontSize: '2.86rem',
                fontWeight: '600',
                formatter(val) {
                  return parseFloat(((val * (10 - 2)) / 100 + 2).toFixed(2))
                },
              },
            },
          },
        },
        fill: {
          type: 'gradient',
          gradient: {
            shade: 'dark',
            type: 'horizontal',
            shadeIntensity: 0.5,
            gradientToColors: [$themeColors.success],
            inverseColors: true,
            opacityFrom: 1,
            opacityTo: 1,
            stops: [0, 100],
          },
        },
        stroke: {
          lineCap: 'round',
        },
        grid: {
          padding: {
            bottom: 30,
          },
        },
      },
      lineChartSimpleTemperaturePh: {
        series: [
          {
            name: 'Temperature',
            data: [],
          },
        ],
        chartOptions: {
          chart: {
            zoom: {
              enabled: false,
            },
            toolbar: {
              show: false,
            },
          },
          markers: {
            strokeWidth: 7,
            strokeOpacity: 1,
            strokeColors: [$themeColors.light],
            colors: [$themeColors.warning],
          },
          colors: ['#28C76F', '#247BA0', '#EA5455'],
          dataLabels: {
            enabled: false,
            value: {
              formatter(val) {
                return val
              },
            },
          },
          stroke: {
            curve: 'straight',
          },
          grid: {
            xaxis: {
              areas: {
                show: true,
              },
            },
          },
          tooltip: {
            custom(data) {
              return `${'<div class="px-1 py-50"><span>'}${data.series[data.seriesIndex][data.dataPointIndex]
              }</span></div>`
            },
          },
          xaxis: {
            categories: [],
            labels: {
              style: {
                colors: '',
              },
            },
          },
          yaxis: {
            labels: {
              style: {
                colors: '',
              },
            },
            min: 6,
            max: 12,
          },
        },
      },
      lineChartSimpleTemperatureCod: {
        series: [
          {
            name: 'Temperature',
            data: [],
          },
        ],
        chartOptions: {
          chart: {
            zoom: {
              enabled: false,
            },
            toolbar: {
              show: false,
            },
          },
          markers: {
            strokeWidth: 7,
            strokeOpacity: 1,
            strokeColors: [$themeColors.light],
            colors: [$themeColors.warning],
          },
          colors: ['#28C76F', '#247BA0', '#EA5455'],
          dataLabels: {
            enabled: false,
            value: {
              formatter(val) {
                return val
              },
            },
          },
          stroke: {
            curve: 'straight',
          },
          grid: {
            xaxis: {
              lines: {
                show: true,
              },
            },
          },
          tooltip: {
            custom(data) {
              return `${'<div class="px-1 py-50"><span>'}${data.series[data.seriesIndex][data.dataPointIndex]
              }</span></div>`
            },
          },
          xaxis: {
            categories: [],
            labels: {
              style: {
                colors: '',
              },
            },
          },
          yaxis: {
            labels: {
              style: {
                colors: '',
              },
            },
            min: 0,
            max: 400,
          },
        },
      },
      lineChartSimpleTemperatureNh3n: {
        series: [
          {
            name: 'Temperature',
            data: [],
          },
        ],
        chartOptions: {
          chart: {
            zoom: {
              enabled: false,
            },
            toolbar: {
              show: false,
            },
          },
          markers: {
            strokeWidth: 7,
            strokeOpacity: 1,
            strokeColors: [$themeColors.light],
            colors: [$themeColors.warning],
          },
          colors: ['#28C76F', '#247BA0', '#EA5455'],
          dataLabels: {
            enabled: false,
            value: {
              formatter(val) {
                return val
              },
            },
          },
          stroke: {
            curve: 'straight',
          },
          grid: {
            xaxis: {
              lines: {
                show: true,
              },
            },
          },
          tooltip: {
            custom(data) {
              return `${'<div class="px-1 py-50"><span>'}${data.series[data.seriesIndex][data.dataPointIndex]
              }</span></div>`
            },
          },
          xaxis: {
            categories: [],
            labels: {
              style: {
                colors: '',
              },
            },
          },
          yaxis: {
            labels: {
              style: {
                colors: '',
              },
            },
            min: 0,
            max: 1,
          },
        },
      },
      lineChartSimpleTemperatureTss: {
        series: [
          {
            name: 'Temperature',
            data: [],
          },
        ],
        chartOptions: {
          chart: {
            zoom: {
              enabled: false,
            },
            toolbar: {
              show: false,
            },
          },
          markers: {
            strokeWidth: 7,
            strokeOpacity: 1,
            strokeColors: [$themeColors.light],
            colors: [$themeColors.warning],
          },
          colors: ['#28C76F', '#247BA0', '#EA5455'],
          dataLabels: {
            enabled: false,
            value: {
              formatter(val) {
                return val
              },
            },
          },
          stroke: {
            curve: 'straight',
          },
          grid: {
            xaxis: {
              lines: {
                show: true,
              },
            },
          },
          tooltip: {
            custom(data) {
              return `${'<div class="px-1 py-50"><span>'}${data.series[data.seriesIndex][data.dataPointIndex]
              }</span></div>`
            },
          },
          xaxis: {
            categories: [],
            labels: {
              style: {
                colors: '',
              },
            },
          },
          yaxis: {
            labels: {
              style: {
                colors: '',
              },
            },
            min: 0,
            max: 300,
          },
        },
      },
      lineChartSimpleTemperatureDebit: {
        series: [
          {
            name: 'Temperature',
            data: [],
          },
        ],
        chartOptions: {
          chart: {
            zoom: {
              enabled: false,
            },
            toolbar: {
              show: false,
            },
          },
          markers: {
            strokeWidth: 7,
            strokeOpacity: 1,
            strokeColors: [$themeColors.light],
            colors: [$themeColors.warning],
          },
          colors: ['#28C76F', '#247BA0', '#EA5455'],
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: 'straight',
          },
          grid: {
            xaxis: {
              lines: {
                show: true,
              },
            },
          },
          tooltip: {
            custom(data) {
              return `${'<div class="px-1 py-50"><span>'}${data.series[data.seriesIndex][data.dataPointIndex]
              }</span></div>`
            },
          },
          xaxis: {
            categories: [],
            labels: {
              style: {
                colors: '',
              },
            },
          },
          yaxis: {
            labels: {
              style: {
                colors: '',
              },
            },
            min: 0,
            max: 300,
          },
        },
      },
      lineChartAlarm: {
        series: [
          {
            name: 'Temperature',
            data: [],
          },
        ],
        chartOptions: {
          chart: {
            zoom: {
              enabled: false,
            },
            toolbar: {
              show: false,
            },
          },
          markers: {
            strokeWidth: 7,
            strokeOpacity: 1,
            strokeColors: [$themeColors.light],
            colors: [$themeColors.warning],
          },
          colors: ['#28C76F', '#247BA0', '#EA5455'],
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: 'straight',
          },
          grid: {
            xaxis: {
              lines: {
                show: true,
              },
            },
          },
          tooltip: {
            custom(data) {
              return `${'<div class="px-1 py-50"><span>'}${data.series[data.seriesIndex][data.dataPointIndex]
              }</span></div>`
            },
          },
          xaxis: {
            categories: [],
            labels: {
              style: {
                colors: '',
              },
            },
          },
          yaxis: {
            labels: {
              style: {
                colors: '',
              },
            },
            min: 0,
            max: 1,
          },
        },
      },
      lineChartUps: {
        series: [
          {
            name: 'Temperature',
            data: [],
          },
        ],
        chartOptions: {
          chart: {
            zoom: {
              enabled: false,
            },
            toolbar: {
              show: false,
            },
          },
          markers: {
            strokeWidth: 7,
            strokeOpacity: 1,
            strokeColors: [$themeColors.light],
            colors: [$themeColors.warning],
          },
          colors: ['#28C76F', '#247BA0', '#EA5455'],
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: 'straight',
          },
          grid: {
            xaxis: {
              lines: {
                show: true,
              },
            },
          },
          tooltip: {
            custom(data) {
              return `${'<div class="px-1 py-50"><span>'}${data.series[data.seriesIndex][data.dataPointIndex]
              }</span></div>`
            },
          },
          xaxis: {
            categories: [],
            labels: {
              style: {
                colors: '',
              },
            },
          },
          yaxis: {
            labels: {
              style: {
                colors: '',
              },
            },
            min: 0,
            max: 1,
          },
        },
      },
      lineChartPln: {
        series: [
          {
            name: 'Temperature',
            data: [],
          },
        ],
        chartOptions: {
          chart: {
            zoom: {
              enabled: false,
            },
            toolbar: {
              show: false,
            },
          },
          markers: {
            strokeWidth: 7,
            strokeOpacity: 1,
            strokeColors: [$themeColors.light],
            colors: [$themeColors.warning],
          },
          colors: ['#28C76F', '#247BA0', '#EA5455'],
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: 'straight',
          },
          grid: {
            xaxis: {
              lines: {
                show: true,
              },
            },
          },
          tooltip: {
            custom(data) {
              return `${'<div class="px-1 py-50"><span>'}${data.series[data.seriesIndex][data.dataPointIndex]
              }</span></div>`
            },
          },
          xaxis: {
            categories: [],
            labels: {
              style: {
                colors: '',
              },
            },
          },
          yaxis: {
            labels: {
              style: {
                colors: '',
              },
            },
            min: 0,
            max: 1,
          },
        },
      },
      realtime_ph: 0,
      realtime_cod: 0,
      realtime_nh3n: 0,
      realtime_tss: 0,
      realtime_debit: 0,
      realtime_alarm: null,
      realtime_ups: null,
      realtime_pln: null,
      history_ph: [],
      history_cod: [],
      history_nh3n: [],
      history_tss: [],
      history_debit: [],
      realtime_time: [],
      icon1,
      icon2,
      datenow: moment(String(new Date())).format("dddd, DD MMM' YYYY LTS"),
      province_id: '',
      regency_id: '',
      district_id: '',
      site_id: '',
      show: false,
      currentTimeInterval: null,
      dashboardInterval: null,
    }
  },
  computed: {
    ...mapState({
      sparing: state => state.temperature.dashboard.sparing,
    }),
    isAdditionalParams() {
      return this.realtime_alarm !== null || this.realtime_ups !== null || this.realtime_pln !== null
    },
  },
  beforeDestroy() {
    if (this.currentTimeInterval) clearInterval(this.currentTimeInterval)
    if (this.dashboardInterval) clearInterval(this.dashboardInterval)
  },
  created() {
    this.show = true
    if (this.isDark === true) {
      this.goalOverviewRadialBarTemperature.plotOptions.radialBar.dataLabels.value.color = '#ffffff'
      this.lineChartSimpleTemperatureDebit.chartOptions.xaxis.labels.style.colors = '#ffffff'
      this.lineChartSimpleTemperatureCod.chartOptions.xaxis.labels.style.colors = '#ffffff'
      this.lineChartSimpleTemperatureNh3n.chartOptions.xaxis.labels.style.colors = '#ffffff'
      this.lineChartSimpleTemperatureTss.chartOptions.xaxis.labels.style.colors = '#ffffff'
      this.lineChartSimpleTemperaturePh.chartOptions.xaxis.labels.style.colors = '#ffffff'
      this.lineChartAlarm.chartOptions.xaxis.labels.style.colors = '#ffffff'
      this.lineChartUps.chartOptions.xaxis.labels.style.colors = '#ffffff'
      this.lineChartPln.chartOptions.xaxis.labels.style.colors = '#ffffff'

      this.lineChartSimpleTemperatureCod.chartOptions.yaxis.labels.style.colors = '#ffffff'
      this.lineChartSimpleTemperatureNh3n.chartOptions.yaxis.labels.style.colors = '#ffffff'
      this.lineChartSimpleTemperaturePh.chartOptions.yaxis.labels.style.colors = '#ffffff'
      this.lineChartSimpleTemperatureTss.chartOptions.yaxis.labels.style.colors = '#ffffff'
      this.lineChartSimpleTemperatureDebit.chartOptions.yaxis.labels.style.colors = '#ffffff'
      this.lineChartAlarm.chartOptions.yaxis.labels.style.colors = '#ffffff'
      this.lineChartUps.chartOptions.yaxis.labels.style.colors = '#ffffff'
      this.lineChartPln.chartOptions.yaxis.labels.style.colors = '#ffffff'
    }
    this.currentTimeInterval = setInterval(() => this.updateCurrentTime(), 1000)
    this.dashboardInterval = setInterval(() => this.getData(), 30000)
    this.getData()
  },
  methods: {
    valueToPercent(val) {
      return ((val - 2) * (100 / (10 - 2))).toFixed(2)
    },
    updateCurrentTime() {
      this.datenow = getCurrentTime()
    },
    getData() {
      this.$store.dispatch('temperature/getDashboardSparingNew').then(resp => {
        this.injectData(resp)
      })
    },
    injectData(resp) {
      this.history_ph = []
      this.history_cod = []
      this.history_nh3n = []
      this.history_tss = []
      this.history_debit = []
      this.history_alarm = []
      this.history_ups = []
      this.history_pln = []
      this.realtime_time = []

      this.realtime_ph = resp.device_realtime.ph
      this.realtime_cod = resp.device_realtime.cod
      this.realtime_nh3n = (resp.device_realtime.tss).toFixed(2)
      this.realtime_tss = resp.device_realtime.nh3n
      this.realtime_debit = resp.device_realtime.debit
      this.realtime_alarm = 'alarm' in resp.device_realtime ? resp.device_realtime.alarm : null
      this.realtime_ups = 'ups' in resp.device_realtime ? resp.device_realtime.ups : null
      this.realtime_pln = 'pln' in resp.device_realtime ? resp.device_realtime.pln : null
      this.lineChartSimpleTemperaturePh.series[0] = {
        name: 'PH Avg : ',
        data: this.history_ph,
      }
      this.lineChartSimpleTemperatureCod.series[0] = {
        name: 'COD Avg : ',
        data: this.history_cod,
      }
      this.lineChartSimpleTemperatureNh3n.series[0] = {
        name: 'NH3N Avg : ',
        data: this.history_nh3n,
      }
      this.lineChartSimpleTemperatureTss.series[0] = {
        name: 'TSS Avg : ',
        data: this.history_tss,
      }
      this.lineChartSimpleTemperatureDebit.series[0] = {
        name: 'Debit Avg : ',
        data: this.history_debit,
      }
      this.lineChartAlarm.series[0] = {
        name: 'Alarm Avg : ',
        data: this.history_alarm,
      }
      this.lineChartUps.series[0] = {
        name: 'UPS Avg : ',
        data: this.history_ups,
      }
      this.lineChartPln.series[0] = {
        name: 'PLN Avg : ',
        data: this.history_pln,
      }

      this.lineChartSimpleTemperaturePh.chartOptions = {
        xaxis: { categories: this.realtime_time },
      }
      this.lineChartSimpleTemperatureCod.chartOptions = {
        xaxis: { categories: this.realtime_time },
      }
      this.lineChartSimpleTemperatureNh3n.chartOptions = {
        xaxis: { categories: this.realtime_time },
      }
      this.lineChartSimpleTemperatureTss.chartOptions = {
        xaxis: { categories: this.realtime_time },
      }
      this.lineChartSimpleTemperatureDebit.chartOptions = {
        xaxis: { categories: this.realtime_time },
      }
      this.lineChartAlarm.chartOptions = {
        xaxis: { categories: this.realtime_time },
      }
      this.lineChartUps.chartOptions = {
        xaxis: { categories: this.realtime_time },
      }
      this.lineChartPln.chartOptions = {
        xaxis: { categories: this.realtime_time },
      }

      this.lineChartSimpleTemperaturePh.chartOptions.annotations = {
        yaxis: [{
          y: 9,
          borderColor: '#F89599',
          label: {
            borderColor: '#F89599',
            style: {
              color: '#fff',
              background: '#F89599',
            },
            text: 'MAX VALUE',
          },
        },
        {
          y: 6,
          borderColor: '#F89599',
          label: {
            borderColor: '#F89599',
            style: {
              color: '#fff',
              background: '#F89599',
            },
            text: 'MIN VALUE',
          },
        }],
      }
      this.lineChartSimpleTemperatureCod.chartOptions.annotations = {
        yaxis: [{
          y: 75,
          borderColor: '#F89599',
          label: {
            borderColor: '#F89599',
            style: {
              color: '#fff',
              background: '#F89599',
            },
            text: 'MAX VALUE',
          },
        },
        {
          y: 0,
          borderColor: '#F89599',
          label: {
            borderColor: '#F89599',
            style: {
              color: '#fff',
              background: '#F89599',
            },
            text: 'MIN VALUE',
          },
        }],
      }
      this.lineChartSimpleTemperatureNh3n.chartOptions.annotations = {
        yaxis: [{
          y: 1,
          borderColor: '#F89599',
          label: {
            borderColor: '#F89599',
            style: {
              color: '#fff',
              background: '#F89599',
            },
            text: 'MAX VALUE',
          },
        },
        {
          y: 0,
          borderColor: '#F89599',
          label: {
            borderColor: '#F89599',
            style: {
              color: '#fff',
              background: '#F89599',
            },
            text: 'MIN VALUE',
          },
        }],
      }
      this.lineChartSimpleTemperatureTss.chartOptions.annotations = {
        yaxis: [{
          y: 50,
          borderColor: '#F89599',
          label: {
            borderColor: '#F89599',
            style: {
              color: '#fff',
              background: '#F89599',
            },
            text: 'MAX VALUE',
          },
        },
        {
          y: 0,
          borderColor: '#F89599',
          label: {
            borderColor: '#F89599',
            style: {
              color: '#fff',
              background: '#F89599',
            },
            text: 'MIN VALUE',
          },
        }],
      }
      this.lineChartSimpleTemperatureDebit.chartOptions.annotations = {
        yaxis: [{
          y: 500,
          borderColor: '#F89599',
          label: {
            borderColor: '#F89599',
            style: {
              color: '#fff',
              background: '#F89599',
            },
            text: 'MAX VALUE',
          },
        },
        {
          y: 0,
          borderColor: '#F89599',
          label: {
            borderColor: '#F89599',
            style: {
              color: '#fff',
              background: '#F89599',
            },
            text: 'MIN VALUE',
          },
        }],
      }

      this.lineChartAlarm.chartOptions.annotations = {
        yaxis: [{
          y: 1,
          borderColor: '#F89599',
          label: {
            borderColor: '#F89599',
            style: {
              color: '#fff',
              background: '#F89599',
            },
            text: 'MAX VALUE',
          },
        },
        {
          y: 0,
          borderColor: '#F89599',
          label: {
            borderColor: '#F89599',
            style: {
              color: '#fff',
              background: '#F89599',
            },
            text: 'MIN VALUE',
          },
        }],
      }
      this.lineChartUps.chartOptions.annotations = {
        yaxis: [{
          y: 1,
          borderColor: '#F89599',
          label: {
            borderColor: '#F89599',
            style: {
              color: '#fff',
              background: '#F89599',
            },
            text: 'MAX VALUE',
          },
        },
        {
          y: 0,
          borderColor: '#F89599',
          label: {
            borderColor: '#F89599',
            style: {
              color: '#fff',
              background: '#F89599',
            },
            text: 'MIN VALUE',
          },
        }],
      }

      this.lineChartPln.chartOptions.annotations = {
        yaxis: [{
          y: 1,
          borderColor: '#F89599',
          label: {
            borderColor: '#F89599',
            style: {
              color: '#fff',
              background: '#F89599',
            },
            text: 'MAX VALUE',
          },
        },
        {
          y: 0,
          borderColor: '#F89599',
          label: {
            borderColor: '#F89599',
            style: {
              color: '#fff',
              background: '#F89599',
            },
            text: 'MIN VALUE',
          },
        }],
      }

      const startIndex = 0
      const endIndex = Math.min(10, resp.device_history.length)
      resp.device_history.slice(startIndex, endIndex).map(x => {
        this.history_ph.push(x.ph)
        this.history_cod.push(x.cod)
        this.history_nh3n.push(x.nh3n)
        this.history_alarm.push(x.alarm)
        this.history_ups.push(x.ups)
        this.history_pln.push(x.pln)

        x.tss = parseFloat(resp.device_realtime.tss).toFixed(2)
        this.history_tss.push(x.tss)

        x.debit = parseFloat(resp.device_realtime.debit * 60).toFixed(1)
        this.history_debit.push(x.debit)

        x.recorded_at = this.$options.filters.formatDateTime(x.recorded_at)
        this.realtime_time.push(x.recorded_at)
      })
      this.show = false
    },
  },
}
</script>
<style lang="scss">
.my-custom-class .card-title {
  color: white;
}
.dot {
  height: 10px;
  width: 10px;
  border-radius: 50%;
  display: inline-block;
}

.normal {
  background-color: #03ff4a;
}

.abnormal {
  background-color: #FC4C02;
}
// .dark-layout .apexcharts-yaxis {
//   color: white;
</style>
